import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as Sentry from '@sentry/angular';

@Injectable()
export class CriticalNetworkErrorInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: unknown) => {
        if (error instanceof HttpErrorResponse && error.status === 0 && this.isApiRequest(request.url)) {
          this.reportCriticalNetworkError(request, error);
        }

        return throwError(() => error);
      }),
    );
  }

  private isApiRequest(url: string): boolean {
    return url.includes('/api');
  }

  private reportCriticalNetworkError(request: HttpRequest<unknown>, error: HttpErrorResponse): void {
    const endpoint = this.extractEndpoint(request.url);
    const readableName = `Critical network error: ${request.method} ${endpoint}`;

    Sentry.captureException(new Error(readableName), (scope) => {
      scope.setLevel('fatal');
      scope.setTag('critical_network_error', 'true');
      scope.setTag('http_status', '0');
      scope.setTag('http_method', request.method);
      scope.setTag('endpoint', endpoint);
      scope.setFingerprint(['network-status-0', request.method, endpoint]);
      scope.setExtra('fullUrl', request.url);
      scope.setExtra('statusText', error.statusText);
      scope.setExtra('payloadLength', this.getPayloadLength(request.body));
      scope.setExtra('hasBody', typeof request.body !== 'undefined' && request.body !== null);

      return scope;
    });
  }

  private extractEndpoint(url: string): string {
    try {
      const parsed = new URL(url);
      return parsed.pathname || url;
    } catch {
      return url;
    }
  }

  private getPayloadLength(payload: unknown): number | null {
    if (payload === undefined || payload === null) {
      return null;
    }

    try {
      return JSON.stringify(payload).length;
    } catch {
      return null;
    }
  }
}


